// extracted by mini-css-extract-plugin
module.exports = {"actionButton":"VideoFxRoomTap_actionButton__1EpEU","leaveMeeting":"VideoFxRoomTap_leaveMeeting__3A_nR"};